import { render } from "./AddBonCommandeFournisseurPage.vue?vue&type=template&id=bd7ae0f2&ts=true"
import script from "./AddBonCommandeFournisseurPage.vue?vue&type=script&lang=ts"
export * from "./AddBonCommandeFournisseurPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__